import * as React from 'react';
import { styled } from 'styled-components';
import CrossPng from '../../images/crossBlack.svg';

const CloseButton = ({ onClick }: Props) => {
	return (
		<CloseButtonContainer>
			<StyledCloseButton onClick={onClick}>
				<StyledCloseImg src={CrossPng} />
			</StyledCloseButton>
		</CloseButtonContainer>
	);
};

interface Props {
	onClick: () => void;
}

export default CloseButton;

const CloseButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: flex-start;
	padding: 18px;
`;

const StyledCloseButton = styled.span`
	width: 20px;
	height: 20px;
	cursor: pointer;
`;

const StyledCloseImg = styled.img`
	width: 100%;
	height: 100%;
`;
